import mapboxgl from "mapbox-gl";
export default class MapLayer {
  list = [];
  map = null;
  bounds = null;
  constructor(mapbox) {
    this.map = mapbox;
    this.bounds = new mapboxgl.LngLatBounds();
  }
  getLayers() {
    return this.list;
  }
  add(marker) {
    marker.addTo(this.map);
    this.bounds.extend(marker.getLngLat());
    this.list.push(marker);
  }
  remove(marker) {
    marker.remove();
  }
  clear() {
    this.list.forEach((marker) => {
      marker.remove();
    });
    this.list = [];
  }
  getBounds() {
    return this.bounds;
  }
}
